export const CONSTANT_LABEL = {
    SAVE_EXIT: 'Save & Exit',
    SAVE_NEW_VERSION: 'Save New Version',
    VERSION_HISTORY: 'Version History',
    REFRESH_DATA: 'Refresh Data',
    DELETE: 'Delete',
    EXPORT: 'Export',
    EXPORT_PDF: 'Export as PDF',
    EXPORT_DOCX: 'Export as DOCX',
    UPLOAD_TO_IMPACT: 'Upload to Impact',
    PREVIEW_DOCUMENT: 'Preview the document',
    DOWNLOAD_FILENAME: 'Provider Negotiation Briefing.docx',
    CLOSE_EXIT: 'Exit',
    FACILITY: 'FACILITY/PHYSICIAN NAME',
    TIERONE: 'TIER 1/2 PROVIDER NAME',
    ANCILARY: 'ANCILLARY NAME',
    PROVIDER_PROFILE: 'Provider Profile',
    CURRENT_STATE: 'Current State',
    PN_STRATERGY: 'Provider Negotiation Strategy',
    EXIT_SAVING: 'Exit without saving?',
    SURE: 'Are you sure?',
    CANCEL: 'Cancel',
    DONE: 'Done',
    TRY_AGAIN: 'Try Again',
    OK: 'OK',
    UPLOAD_SUCCESS_MSG: 'Successfully uploaded to Impact.',
    UPLOAD_ERROR_MSG: 'Document did not upload, please try again.',
    UPLOAD_ERROR_MSG_NO_GENESIS: 'Document did not upload',
    UPLOAD_ERROR_NO_GENESIS_MSG: 'Missing Tax ID/Parent Entity in IMPACT, please add in Genesis.  In the interim, please manually upload the document. ',
    UPLOAD_ERROR_PARENT_ENTITY_MSG: 'Missing Parent Entity in IMPACT, please add in Genesis. In the interim, please manually upload the document.',
    EXIT_WITHOUT_SAVING: 'Exit without Saving',
    REFRESH_SURE: 'Are you sure you would like to refresh data?',
    OVERWRITE: 'Overwrite ',
    ALL_FIELDS: 'All Fields ',
    FIELDS_TAG_REFRESH: 'including your overwritten fields.',
    REFRESH_RADIO: 'Only Overwrite unedited fileds - keep your overwritten fields.',
    DELETE_INTRO: 'Provider Negotiation Briefing for ',
    SELECT_OPTION: 'Select option:',
    ALL_VERSION: 'All Versions',
    DELETE_TAG_LABEL: ' including your overwritten fields. This can’t be undone.',
    DELETE_RADIO: 'Delete current version only.',
    PRINT: 'Print Page',
    EDIT: 'Edit',
    CLOSE: 'Close',
    SAVE: 'Save',
    RED: 'Red = serious threat/member abrasion',
    YELLOW:'Yellow = possible disruption/provider still engaged',
    GREEN: 'Green = low risk of potential disruption',
    EI: 'E&I: ',
    EI_ANCILLARY: 'E&I: ',
    FI: 'FI: ',
    ASO: 'ASO: ',
    MR: 'M&R: ',
    CS: 'C&S: ',
    IFP: 'IFP: ',
    TOTAL: 'Total Spend: ',
    FQHC: 'FQHC: ',
    FQHCLA: 'FQHCLA: ',
    RHC: 'RHC: ',
    THC: 'THC: ',
    LEGAL_ONE: 'Is The Provider A UHG Affiliate ',
    LEGAL_TWO: 'per the Legal Entities list in the NC-74 policy?',
    PROVIDER_DETAILS: 'Provider Details',

};
export const HEADER_DATA = {
    headerData: [
    { name: 'Region', value: ''},
    { name: 'State', value: ''},
    { name: 'Market', value: ''},
    { name: 'Tax ID Type', value: ''},
    { name: 'Financial Ownership', value: ''}],
    headerValue: ''
};
export const HISTORY_DATA = [
    { date: '08/08/2024 - 00:00:00 {localtime}'},
    { date: '08/08/2024 - 00:00:00 {localtime}'},
    { date: '08/08/2024 - 00:00:00 {localtime}'}
];
export const TIME = 'Viewing data from 08/30/2024 00:00:00 PM';
export const FinancialStatus = [
    { value: 'For profit', label: 'For profit' },
    { value: 'Not-for-profit organization', label: 'Not-for-profit organization' }
  ];
  export const RelationshipStatus = [
    { value: 'Red', label: 'Red' },
    { value: 'Yellow', label: 'Yellow' },
    { value: 'Green', label: 'Green' }
  ];
  export const optionValueCheck = ['privateEquityBacked', 'financialStatus', 'relationshipStatus', 'uhcCustomer'];
  export const PnbModifiedOptions = {
    ancillary: 'ANCILLARY',
    facility: 'FACILITY',
    tier: 'TIER 1/2',
    tier2: 'TIER 1 & 2',
};

export const fieldNames = {
    'providerName': 'Provider Name',
    'relationshipStatus': 'Relationship Status',
    'headQuarters': 'Headquarters',
    'uhcCustomer': 'UHC Customer',
    'leadership': 'Leadership',
    'privateEquityBacked': 'Private Equity Backed',
    'privateEquityName': 'Private Equity Name (If applicable)',
    'totalHospitals': '# Hospitals',
    'totalBeds': '# Beds',
    'outpatientCenters': 'Outpatient Centers',
    'physicians': '# Physicians',
    'ambulatorySurgicalCenters': '# Ambulatory Surgical Centers (ASC)',
    'ambulatoryInfusionSuites': '# Ambulatory Infusion Suites (AIS)',
    'federallyQualifiedHeathCenters': '# Federally Qualified Health Centers (FQHC), # FQHC Look-Alike (FQHCLA), # Rural Health Centers (RHC), # Tribal Health Center (THC)',
    'homeInfusionCenters': '# Home Infusion Centers (HIT)',
    'hemophiliaTreatmentCenters': '# Hemophilia Treatment Centers (HTC)',
    'specialtyPharmacy': '# Specialty Pharmacy (SP)',
    'financialStatus': 'Financial Status',
    'profitabilityPercentage': '% Profitability',
    'spend': 'Spend',
    'majorityFinancialOwnership': 'Majority Financial Ownership',
    'isLegal': '',
    'ancillaryCount': '# Ancillary',
    'providerGroupCount': '# Provider Groups',
};
export const SelectOptions = [
    { value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' }
  ];

export const PnbOptions = {
    ancillary: 'Ancillary',
    facility: 'Facility',
    tier: 'Tier 1 & 2 Independent Physician Group'
};

export const pnbOptionsMapping = {
    "FACILITY": 'Facility',
    "TIER_1_2_INDEPENDENT_PHYSICIAN_GROUPS" : 'Tier 1 & 2 Independent Physician Group',
    "ANCILLARY" : 'Ancillary',
    "Facility": 'Facility',
    "Tier 1 & 2 Independent Physician Group": 'Tier 1 & 2 Independent Physician Group',
    "Ancillary": 'Ancillary'
};

export const providerProfileAutomatedFields = [
    "providerName",
    "privateEquityBacked",
    "totalBeds",
    "physicians",
    "federallyQualifiedHeathCenters",
    "isLegal",
    'totalHospitals',
    'ancillaryCount',
    'providerGroupCount',
    "leadership",
    "Headquarters",
    "profitabilityPercentage",
    "financialStatus",
    "spend"
];

export const providerProfileAncilalary = {
        'providerName': 'Firstname Lastname',
        'relationshipStatus': 'Select One',
        "Headquarters": [
            { 'Headquarters': 'City/State', 'taxid': 'XXXXXXXX', 'taxName': 'XXXXX'}
        ],
        'uhcCustomer': {
        'value': 'Select Yes or No',
        },
        "leadership": [
            { 'leadership': 'CEO Name', 'taxid': 'XXXXXXXX', 'taxName': 'XXXXX'}
        ],
        'privateEquityBacked': {
            'value': 'Select Y or N',
            'explanation': '[If yes, please explain. If no, write N/A]'
        },
        // commented these fields as per new requirement
        // 'ambulatorySurgicalCenters': '[#]',
        // 'ambulatoryInfusionSuites': '[#]',
        // 'homeInfusionCenters': '[#]',
        // 'specialtyPharmacy': '[#]',
        // 'hemophiliaTreatmentCenters': '[#]',
        'totalHospitals': '[#]',
        'ancillaryCount': '[#]',
        'providerGroupCount': '[#]',
        "financialStatus": [
            { 'financialStatus': 'Select One', 'taxid': 'XXXXXXXX', 'taxName': 'XXXXX'}
        ],
        'spend': {
          'E&I': '',
          'M&R': '',
          'C&S': '',
          'IFP': '',
          'totalSpends': ''
        },
        'majorityFinancialOwnership': '[Insert majority financial information]',
        'isLegal': 'Y/N'
};
export const providerProfileFacility = {
    'providerName': 'Firstname Lastname',
    'relationshipStatus': 'Select One',
    "Headquarters": [
            { 'Headquarters': 'City/State', 'taxid': 'XXXXXXXX', 'taxName': 'XXXXX'}
        ],
    'uhcCustomer': {
        'value': 'Select Yes or No',
    },
    "leadership": [
            { 'leadership': 'CEO Name', 'taxid': 'XXXXXXXX', 'taxName': 'XXXXX'}
        ],
    'privateEquityBacked': {
        'value': 'Select Y or N',
        'explanation': '[If yes, please explain. If no, write N/A]'
    },
    'totalHospitals': '[#]',
    // commented these fields as per new requirement
    //'outpatientCenters': '[#]',
    // 'ambulatorySurgicalCenters': '[#]',
    // 'ambulatoryInfusionSuites': '[#]',
    // 'homeInfusionCenters': '[#]',
    // 'specialtyPharmacy': '[#]',
    // 'hemophiliaTreatmentCenters': '[#]',
    'ancillaryCount': '[#]',
    'providerGroupCount': '[#]',
    'totalBeds': '[#]',
    'physicians': '[#]',
    'federallyQualifiedHeathCenters': {
      'FQHC': '',
      'FQHC LA': '',
      'RHC': '',
      'THC': ''
    },
    "financialStatus": [
            { 'financialStatus': 'Select One', 'taxid': 'XXXXXXXX', 'taxName': 'XXXXX'}
        ],
    "profitabilityPercentage": [
            { 'profitabilityPercentage': '[X]', 'taxid': 'XXXXXXXX', 'taxName': 'XXXXX'}
        ],
    'spend': {
      'E&I Total': '',
      'ASO': '',
      'FI': '',
      'M&R': '',
      'C&S': '',
      'IFP': '',
      'totalSpends': ''
    },
    'majorityFinancialOwnership': '[Insert majority financial information]',
    'isLegal': 'Y/N'
};
export const providerProfileTierOne = {
    'providerName': 'Firstname Lastname',
    'relationshipStatus': 'Select One',
    "Headquarters": [
            { 'Headquarters': 'City/State', 'taxid': 'XXXXXXXX', 'taxName': 'XXXXX'}
        ],
    'uhcCustomer': {
        'value': 'Select Yes or No',
    },
    "leadership": [
            { 'leadership': 'CEO Name', 'taxid': 'XXXXXXXX', 'taxName': 'XXXXX'}
        ],
    'privateEquityBacked': {
        'value': 'Select Y or N',
        'explanation': '[If yes, please explain. If no, write N/A]'
    },
    'privateEquityName': '[Name]',
    "financialStatus": [
            { 'financialStatus': 'Select One', 'taxid': 'XXXXXXXX', 'taxName': 'XXXXX'}
        ],
    'spend': {
      'E&I Total': '',
      'ASO': '',
      'FI': '',
      'M&R': '',
      'C&S': '',
      'IFP': '',
      'totalSpends': ''
    },
    'majorityFinancialOwnership': '[Insert majority financial information]',
    'isLegal': 'Y/N'
};
// const formattedValue = value.replace(/^- |\n\s*-/g, '\n•');

export const currentStateFacility = {
    "currentRelationshipContractDetails": {
        "narrative": `In narrative form, describe the provider's importance to the market, including the items below as applicable:
        • Provider's overall value in the market and to UHC
        • Network adequacy - Geographic coverage
        • Network adequacy - Service line coverage
        • Product Participation (Include VA CCN spend details if applicable)
        • Specify if the health system is contracted for AIS/HIT/SP/HTC and provide related details
        • Narrow network product participation
        • Value-Based relationships, including VBC and ACO
        • Optum relationship (OptumCare, OBH, Transplant, etc.)
        • Other strategic initiatives/relationships`,
    },
    "baselineContractScoreRates": {
        "contractScore": "Enter contract score and identify top drivers/ areas of improvement",
        "improvementDrivers": ""
    },
    "nonStandardLanguage": {
        "narrative": "Describe any Non Standard Language and any areas of improvement"
    },
    "externalLeadershipContacts": {
        "primaryNegotiator": {
            "fullName": "[Include full names, title and contact information, including email and phone number. Specify the primary negotiator and secondary negotiator",
            "title": "",
            "email": "",
            "phoneNumber": ""
        },
        "secondaryNegotiator": {
            "fullName": "",
            "title": "",
            "email": "",
            "phoneNumber": ""
        }
    },
    "unitedHealthcareMembershipMarketSharePosition": {
        "lineOfBusiness": {
            "marketName": {
                "membership": ["[XXM]", "[XXM]", "[XXM]"]
            },
            "commercial": {
                "membership": ["[XXM]", "[XXM]", "[XXM]"],
                "marketShare": "[%]",
                "marketRanking": {
                    "marketRank": "",
                    "fi": "[X]",
                    "aso": "[X]"
                }
            },
            "medicare": {
                "membership": ["[XXM]", "[XXM]", "[XXM]"],
                "marketShare": "[%]",
                "marketRanking": {
                    "marketRank": "[X]"
                }
            },
            "medicaid": {
                "membership": ["[XXM]", "[XXM]", "[XXM]"],
                "marketShare": "[%]",
                "marketRanking": {
                    "marketRank": "[X]"
                }
            },
            "ifp": {
                "membership": ["[XXM]", "[XXM]", "[XXM]"],
                "marketShare": "[%]",
                "marketRanking": {
                    "marketRank": "[X]"
                }
            }
        }
    },
    "marketCompetitiveness": {
        "uhcMarketNetworkEfficiencyFactorNEF": "[X]",
        "uhcProviderNEF": "[X]",
        "providerBestInClassBICPayorName": "[Enter name]",
        "marketInsightsFactors": "[Enter narrative]"
    },
    "currentContractTerms": {
        "renewalTermDate": [
            "[XX/XX/XX]",
        ],
        "previewRenewalTermDate": [
            { timePeriod: "XX/XX/XX", tin: "XXXXXXXXX", provider: "XXXXX" }
        ],
        "previewCurrentContractTermRateProvision": [
            { timePeriod: "[__] year deal / [__] days advance notice of term", tin: "XXXXXXXXX", provider: "XXXXX" },
        ],
        "currentContractTermRateProvision": [
            "[__] year deal / [__] days advance notice of term",
        ],
        "historicalIncreases": {
            "averageValue": "[XX%$]",
            "cumulativeValue": "[XX%$]"
        },
        "cpiHospitalOrPhysician": {
            "averageValue": "[XX%$]",
            "cumulativeValue": "[XX%$]"
        },
        "paperTypeAndVersion": "[Enter current template (FPA/MGA), payment appendix year, standard, non-standard, version number, etc. ]"
    },
    "contractRateMethodologyCompetitivenessOverviewByLineOfBusiness": {
        "trendDriversAcrossAllLinesOfBusiness": "[List drivers and explain their importance]",
        "commercial": {
            "commercialUnitCostReportingTemplateUCRTProjection": "X%",
            "commercialExposureToPercentageOfPaymentRatePPR": {
                "inpatient": "X",
                "outpatient": "X",
                "total": "X"
            },
            "commercialPPREquivalent": "X%",

            "hospitalCostToChargeRatio": [
            { "hospitalCostToChargeRatio": "X%", 'taxid': 'XXXXXXXX', 'taxName': 'XXXXX'}
            ],
            "commercialBICPosition": {
                "payor": "Name of Payor",
                "hospital": "% Advantaged or Disadvantaged/$",
                "physician": "% Advantaged or Disadvantaged/$",
                "combinedSystemBIC": "X%"
            },
            "commercialProviderRelativityToPeers": {
                "facilityRVU": "$X",
                "higherThan": "<Peer> $X",
                "lowerThan": "<Peer> $X",
                "physician": "X% of Medicare",
                "market": "% Higher or Lower"
            },
            "commercialRateAsPercentageOfCMS": {
                "market": "X%",
                "physician": "X%"
            },
            "commercialPayApps": `Enter age of pay apps and pay app year. Also include the following:
        • If > 5 years, outline strategy to move to Most Current
        • Most current Regulatory Appendix (Need parameters)
        • Is there chargemaster protection for PPR rates and the ability to offset
        • Are there specialty pharmacy rates Remediation`,
        },
        "medicare": {
            "medicareRemediation": {
                "target": "Remediation target ? Select one Savings XX%: $XX",
                "savings": "%",
                "stateRate": "$"
            },
            "medicareReimbursement": {
                "facility": "XX",
                "physicians": "XXX% for PPO [From contract]",
                "ascs": "% [From contract]",
                "globalCapRate": "XX% [From contract]"
            },
            "medicarePayApps": `Enter age of fee schedule and CMS year. Also include the following:
        • If > 5 years, outline strategy to move to Most Current
        • Most current Regulatory Appendix (Need parameters)
        • Is there chargemaster protection and the ability to offset ?`,
        },
        "medicaid": {
            "medicaidRemediation": {
                "target": "Remediation target ? Select one Savings XX%: $XX",
                "savings": "XX% [From C&S UCRT Report]",
                "stateRate": "$XX [From C&S UCRT Report]"
            },
            "medicaidReimbursement": {
                "facility": "XXX% [From contract]",
                "physicians": "XXX% [From contract]",
                "ascs": "XXX% [From contract]",
            },
            "medicaidPayApps": `Enter age of fee schedule and CMS year. Also include the following:
        • If > 5 years, outline strategy to move to Most Current
        • Most current Regulatory Appendix (Need parameters)
        • Is there chargemaster protection and the ability to offset ?`,
        },
        "ifp": {
            "ifpReimbursement": {
                "facility": "[Zone 1,2,3]",
                "physicians": "Include % CMS or Decrement from Ch+",
                "ascs": "Include ancillary type(s)",
                "globalCapRate": "XX%[From contract]"
            },
            "ifpBICPositionMarketCompetitiveness": {
                "payor": "Name of payor with lowest premium",
                "rateDifference": "$",
                "premiumPosition": "1,2,3,4 etc.",
                "pricingZone": "Zone 1, Zone 2, Zone 3"
            },
            "ifpRemediation": {
                "target": "Remediation target ? Select one Savings XX% : $XX",
                "hospitalTarget": "Include % CMS or Decrement from Ch+ & Pricing Zone [Zone 1, 2, 3]",
                "hospitalStrategy": "Is the strategy to move OON from INN ? [Yes or No]",
                "physicianTarget": "Include % CMS or Decrement from Ch+",
                "ancillaryTarget": "[Narrative Description]"
            },
            "ifpFeeSchedule": `Enter age of fee schedule and CMS year. Also include the following:
        • If > 5 years, outline strategy to move to Most Current
        • Most current Regulatory Appendix (Need parameters)
        • Is there chargemaster protection and the ability to offset ?
        • Specify if Pay Apps are IFP Specific and if Escalators are included`,
        }
    },
    "exclusionsExceptions": {
        "affordability": [
            "List affordability programs this provider uses or has an opportunity to implement, along with their LOBs: - Any value-based exceptions or exclusions?",
            "Are we going to continue these exceptions or exclusions?",
            "Is there an opportunity to add/change these? Explain"
        ],
        "valueBasedReimbursement": {
            "ValueBasedTrade": [
                "List value-based programs this provider uses or has an opportunity to implement, along with their LOBs: - Any value-based exceptions or exclusions?",
                "Are we going to continue these exceptions or exclusions?",
                "Is there an opportunity to add/change these? Explain",
                "Enter narrative about performance-based contracting or lump sum payments by year Description and Performance Summary: - Outline each LOB – Notate any IFP Specific VBC Participation - What is provider’s current performance?",
                "Is there opportunity to remediate or add ACO/VBC?"
            ]
        },
        "competitiveness": [
            "List competitiveness programs (e.g., lump sum) used previously or to be considered in upcoming negotiation for each LOB: - Any value-based exceptions or exclusions?",
            "Are we going to continue these exceptions or exclusions?",
            "Is there an opportunity to add/change these? Explain"
        ],
    },
    "contractAllowance": {
        "clinical": [
            "Any value-based exceptions or exclusion?",
            "Are we going to continue these exceptions or exclusions:",
            "Is there an opportunity to add/change these?",
            "Explain"
        ],
        "network": [
                    "Any value-based exceptions or exclusion?",
                    "Are we going to continue these exceptions or exclusions:",
                    "Is there an opportunity to add/change these?",
                    "Explain"
        ],
        "pharmacy": [
            "Any value-based exceptions or exclusion?",
            "Are we going to continue these exceptions or exclusions:",
            "Is there an opportunity to add/change these?",
            "Explain"
        ],
        "paymentIntegrity": [
            "Any value-based exceptions or exclusion?",
            "Are we going to continue these exceptions or exclusions:",
            "Is there an opportunity to add/change these?",
            "Explain"
        ],
        "paymentIntegrityClinical": [
            "Any value-based exceptions or exclusion?",
            "Are we going to continue these exceptions or exclusions:",
            "Is there an opportunity to add/change these?",
            "Explain"
        ],
        "paymentIntegrityNonClinical": [
            "Any value-based exceptions or exclusion?",
            "Are we going to continue these exceptions or exclusions:",
            "Is there an opportunity to add/change these?",
            "Explain"
        ],
        "paymentIntegrityReimbursementPolicy": [
            "Any value-based exceptions or exclusion?",
            "Are we going to continue these exceptions or exclusions:",
            "Is there an opportunity to add/change these?",
            "Explain"
        ],
        "other": [
            "Outline each LOB-Notate any IFP Specific VBC Participation",
            "What is providers’ current performance?",
            "Is there opportunity to remediate or add ACO/VBC"
        ],
    },
    "operationsOverview": {
        "narrative":`Enter narrative, including how the following affects strategy:
        • Top 3-5 provider abrasion points (overall pain points)`,
        "claimsYeild": `Claims Yield-Contract Yield`,
        "topProviderAbrasionPoints": {
            "abrasionPoint1": "",
            "abrasionPoint2": "",
            "abrasionPoint3": "",
            "abrasionPoint4": "",
            "abrasionPoint5": ""
        },
        "claimsYieldContractYield": {
            "contractYield": "$",
            "claimsYield": ""
        },
        "grossYield": {
            "grossYieldEI": "",
            "grossYieldMR": "",
            "grossYieldCS": "",
        },
        "sourceOfInformation": ""
    }
};

export const currentStateAncillary = {
    "demographicCoverage": {
        "narrative": "Describe demographic coverage"
    },
    "relationshipOverview": {
        "narrative": `In narrative form, describe the provider's importance to the market, including the items below as applicable:
        • Provider's overall value in the market and to UHC
        • Network adequacy - Geographic coverage
        • Network adequacy - Service line coverage
        • Product Participation
        • Narrow network product participation
        • Value-Based relationships, including VBC and ACO
        • Optum relationship (OptumCare, OBH, Transplant, etc.)
        • Other strategic initiatives/relationships
        • Merger and acquisition activity`,
    },
    "optumRelationship": {
        "narrative": "Describe Optum Relationship, or put N/A. Include sources of revenue, what products have we sold them."
    },
    "leadershipContacts": {
        "primaryContact": {
            "Name": "Name",
            "Role": "Role"
        },
        "cfoName": {
            "Name": "Name",
            "Role": "Role"
        },
        "otherContact": {
            "Name": "Name",
            "Role": "Role"
        }
    },
    "marketCompetitiveness": {
        "providerBestInClassBICPayor": "Enter name",
        "ticData": "[X]",
        "marketInsightsFactors": "Enter narrative"
    },
    "currentContractTerms": {
        "renewalTermDate": [
            "[XX/XX/XX]",
        ],
        "previewRenewalTermDate": [
            { timePeriod: "XX/XX/XX", tin: "XXXXXXXXX", provider: "XXXXX" }
        ],
        "previewCurrentContractTermRateProvision": [
            { timePeriod: "[__] year deal / [__] days advance notice of term", tin: "XXXXXXXXX", provider: "XXXXX" },
        ],
        "currentContractTermRateProvision": [
            "[__] year deal / [__] days advance notice of term",
        ],
        "historicalIncreasesEI": {
            "averageValue": "[XX%/$]",
            "cumulativeValue": "[XX%/$]"
        },
        "historicalIncreasesAll": {
            "averageValue": "[XX%/$]",
            "cumulativeValue": "[XX%/$]"
        },
        "paperTypeAndVersion": "[Enter current template (FPA/MGA), payment appendix year, standard, non- standard, version number, base type, base remediation etc.",
        "paymentAppendix": `Template name and version
Standard? Enter Yes or No
Payment Appendix Remediation Required ? Enter Yes or No
`,
    },
    "contractRateMethodologyCompetitivenessOverviewByLineOfBusiness": {
        "trendDriversAcrossAllLinesOfBusiness": "[List drivers and explain their importance]",
        "otherNetworkCommentary": "[Enter any additional, necessary commentary. This may include Narrow Networks, VACCN, IFP, etc.]",
        "commercial": {
            "commercialUnitCostReportingTemplateUCRTProjection": "X% and effective date (multiple years as appropriate)",
            "commercialExposureToPercentageOfPaymentRatePPR": "X% of spend and dollar amount or can be N/A",
            "commercialRemediation": {
                "target": "Enter Yes or No",
                "remediationGoals": "XXX",
            },
            "commercialReimbursement": {
                "currentShareofMedicine": "X%",
                "feeSchedule": "XXX"
            }
        },
        "ifp": {
            "ifpReimbursement": `[Enter description of any IFP specific reimbursement rates, Remediation goals or Pay Apps if applicable. Also include the following]
        • Pricing Zone
        • Global Cap Rate
        • Remediation Targets
        • IFP Specific Pay App age and details`,
        },
        "medicare": {
            "medicareRemediation": {
                "target": "Enter Yes or No",
                "remediationGoals": "XXX",
            },
            "medicareReimbursement": {
                "currentShareofMedicare": "XX%",
                "feeSchedule": "XX"
            }
        },
        "medicaid": {
            "medicaidRemediation": {
                "target": "Enter Yes or No",
                "remediationGoals": "XXX"
            },
            "medicaidReimbursement": {
                "PASP": "Enter Yes or No",
                "currentRateMedicaid": "XX%",

            }
        },

    },
   "operationsOverviewD": {
        "claimsYield": {
            "contractYield": "$",
            "claimsYield": "%"
        },
        "grossYield": {
            "grossYieldEI": "",
            "grossYieldMR": "",
            "grossYieldCS": "",
        },
        "activeSettlements": "$XX Provider Demand",
        "reasonForPastSettlements":"XX",
        "topReasons": {
            first: "1.",
            second: "2.",
            third: "3.",
        },
        "summaryCNP": {
            "mrecords": {
                EI: "%",
                MR: "%",
                IFP: "%",
                CS: "%"
            },
            "submitted": {
                EI: "#",
                MR: "#",
                IFP: "#",
                CS: "#"
            },
            "denied": {
                EI: "#",
                MR: "#",
                IFP: "#",
                CS: "#"
            },
        }
    },
    "performanceVBP": {
        "narrative": "[Enter narrative about quality or performance- based payments]"
    },
    "optumClaimMedical": {
        "narrative": "Volume ? How is it impacting the provider's cash flow ?"
    },
    "additionalComments": {
        "narrative": "XXX"
    }
};

export const currentStateTierOne = {
    "currentRelationshipContractDetails": {
        "narrative": `In narrative form, describe the provider's importance to the market, including the items below as applicable:
        • Provider's overall value in the market and to UHC
        • Network adequacy - Geographic coverage
        • Network adequacy - Service line coverage
        • Product Participation (Include VA CCN spend details if applicable)
        • Specify if the health system is contracted for AIS/HIT/SP/HTC and provide related details
        • Narrow network product participation
        • Value-Based relationships, including VBC and ACO
        • Optum relationship (OptumCare, OBH, Transplant, etc.)
        • Other strategic initiatives/relationships`,
    },
    "baseReviewRatesLang": {
        "contractScore": "Identify top drivers/areas of improvement",
        "improvementDrivers": "Identify top drivers/areas of improvement"
    },
    "externalLeadershipContacts": {
        "primaryNegotiator": {
            "fullName": "[Include full names, title, and contact information, including email and phone number. Specify the primary negotiator and secondary negotiator",
            "title": "",
            "email": "",
            "phoneNumber": ""
        },
        "secondaryNegotiator": {
            "fullName": "",
            "title": "",
            "email": "",
            "phoneNumber": ""
        }
    },
    "unitedHealthcareMembershipMarketSharePosition": {
        "lineOfBusiness": {
            "marketName": {
                "membership": ["[XXM]", "[XXM]", "[XXM]"]
            },
            "commercial": {
                "membership": ["[XXM]", "[XXM]", "[XXM]"],
                "marketShare": "[%]",
                "marketRanking": {
                    "marketRank": "[X]"
                }
            },
            "medicare": {
                "membership": ["[XXM]", "[XXM]", "[XXM]"],
                "marketShare": "[%]",
                "marketRanking": {
                    "marketRank": "[X]"
                }
            },
            "medicaid": {
                "membership": ["[XXM]", "[XXM]", "[XXM]"],
                "marketShare": "[%]",
                "marketRanking": {
                    "marketRank": "[X]"
                }
            },
            "ifp": {
                "membership": ["[XXM]", "[XXM]", "[XXM]"],
                "marketShare": "[%]",
                "marketRanking": {
                    "marketRank": "[X]"
                }
            }
        }
    },
    "marketCompetitiveness": {
        "uhcProviderNEF": "[X]",
        "providerBestInClassBICPayorName": "[Enter name]",
        "marketInsightsFactors": "[Enter narrative]"
    },
    "currentContractTerms": {
        "renewalTermDate": [
            "[XX/XX/XX]",
        ],
        "previewRenewalTermDate": [
            { timePeriod: "XX/XX/XX", tin: "XXXXXXXXX", provider: "XXXXX" },
        ],
        "previewCurrentContractTermRateProvision": [
            { timePeriod: "[__] year deal / [__] days advance notice of term", tin: "XXXXXXXXX", provider: "XXXXX" },
        ],
        "currentContractTermRateProvision": [
            "[__] year deal / [__] days advance notice of term",
        ],
        "historicalIncreases": {
            "averageValue": "[XX%$]",
            "cumulativeValue": "[XX%$]"
        },
        "cpiHospitalOrPhysician": {
            "averageValue": "[XX%$]",
            "cumulativeValue": "[XX%$]"
        },
        "nonStandardLanguage": {
            narrative: "Enter narrative, discussing: Is there any non-standard language for remedian opportunity ? (e.g., claims denials, rework, arbitration/settlements)"
        },
        "paperTypeAndVersion": "[Enter current template (FPA/MGA), payment appendix year, standard, non-standard, version number, base type, base remedian etc. ]"
    },
    "contractRateMethodologyCompetitivenessOverviewByLineOfBusiness": {
        "trendDriversAcrossAllLinesOfBusiness": "[List drivers and explain their importance]",
        "commercial": {
            "commercialUnitCostReportingTemplateUCRTProjection": "X%",
            "commercialExposureToPercentageOfPaymentRatePPR": {
                "total": "Total: X"
            },
            "commercialPPREquivalent": "X%",
            "hospitalCostToChargeRatio": "",
            "commercialBICPosition": {
                "payor": "Name of Payor",
                "physician": "% Advantaged or Disadvanataged / $",
            },
            "commercialProviderRelativityToPeers": {
                "higherThan": "<Peer> $X",
                "lowerThan": "<Peer> $X",
                "physician": "X% of Medicare",
                "market": "% Higher or Lower"
            },
            "commercialFeeSchedule": `Enter age of fee schedule and CMS year. Also include the following:
        • If > 5 years, outline strategy to move to Most Current
        • Most current Regulatory Appendix (Need parameters)
        • Is there chargemaster protection for PPR rates and the ability to offset ?`,
        },
        "medicare": {
            "medicareRemediation": {
                "target": "Remediation target? Select one Savings XX%: $XX"
            },
            "medicareReimbursement": {
                "physicians": "XXX % for PPO [From contract]"
            },
            "medicareFeeSchedule": `Enter age of fee schedule and CMS year. Also include the following:
        • If > 5 years, outline strategy to move to Most Current
        • Most current Regulatory Appendix (Need parameters)
        • Is there chargemaster protection and the ability to offset ?`,
        },
        "medicaid": {
            "medicaidRemediation": {
                "target": "Remediation target? Select one"
            },
            "medicaidReimbursement": {
                "physicians": "XXX% [From Contract]"
            },
            "medicaidPayApps": `Enter age of fee schedule and CMS year. Also include the following:
        • If > 5 years, outline strategy to move to Most Current
        • Most current Regulatory Appendix (Need parameters)
        • Is there chargemaster protection for PPR rates and the ability to offset?`,
        },
        "ifp": {
            "ifpReimbursement": {
                "physicians": "Include % CMS or Decrement from Ch+",
                "globalCapRate": "XX% [From contract]"
            },
            "ifpBICPositionMarketCompetitiveness": {
                "payor": "Name of payor with lowest premium",
                "rateDifference": "$",
                "premiumPosition": "[1,2,3,4 etc.]",
                "pricingZone": "[Zone 1, Zone 2, Zone 3]"
            },
            "ifpRemediation": {
                "target": "Remediation target? Include % CMS or Decrement from Ch+",
            },
            "ifpFeeSchedule": `Enter age of fee schedule and CMS year. Also include the following:
        • If > 5 years, outline strategy to move to Most Current
        • Most current Regulatory Appendix (Need parameters)
        • Is there chargemaster protection and the ability to offset ?
        • Specify if Pay Apps are IFP Specific and if Escalators are included`,
        }
    },
    "exclusionsExceptions": {
            "affordability": [
                "List affordability programs this provider uses or has an opportunity to implement, along with their LOBs: - Any value-based exceptions or exclusions?",
                "Are we going to continue these exceptions or exclusions?",
                "Is there an opportunity to add/change these? Explain"
            ],
            "valueBasedReimbursement": {
                "ValueBasedTrade": [
                    "List value-based programs this provider uses or has an opportunity to implement, along with their LOBs: - Any value-based exceptions or exclusions?",
                    "Are we going to continue these exceptions or exclusions?",
                    "Is there an opportunity to add/change these? Explain",
                    "Enter narrative about performance-based contracting or lump sum payments by year Description and Performance Summary:",
                    "Outline each LOB – Notate any IFP Specific VBC Participation",
                    "What is provider’s current performance?",
                    "Is there opportunity to remediate or add ACO/VBC?"
                ]
            },
            "competitiveness": [
                "List competitiveness programs (e.g., lump sum) used previously or to be considered in upcoming negotiation for each LOB: - Any value-based exceptions or exclusions?",
                "Are we going to continue these exceptions or exclusions?",
                "Is there an opportunity to add/change these? Explain"
            ],
    },

    "contractAllowance": {
        "clinical": [
            "Any value-based exceptions or exclusion?",
            "Are we going to continue these exceptions or exclusions:",
            "Is there an opportunity to add/change these?",
            "Explain"
        ],
        "network": [
                    "Any value-based exceptions or exclusion?",
                    "Are we going to continue these exceptions or exclusions:",
                    "Is there an opportunity to add/change these?",
                    "Explain"
        ],
        "pharmacy": [
            "Any value-based exceptions or exclusion?",
            "Are we going to continue these exceptions or exclusions:",
            "Is there an opportunity to add/change these?",
            "Explain"
        ],
        "paymentIntegrity": [
            "Any value-based exceptions or exclusion?",
            "Are we going to continue these exceptions or exclusions:",
            "Is there an opportunity to add/change these?",
            "Explain"
        ],
        "paymentIntegrityClinical": [
            "Any value-based exceptions or exclusion?",
            "Are we going to continue these exceptions or exclusions:",
            "Is there an opportunity to add/change these?",
            "Explain"
        ],
        "paymentIntegrityNonClinical": [
            "Any value-based exceptions or exclusion?",
            "Are we going to continue these exceptions or exclusions:",
            "Is there an opportunity to add/change these?",
            "Explain"
        ],
        "paymentIntegrityReimbursementPolicy": [
            "Any value-based exceptions or exclusion?",
            "Are we going to continue these exceptions or exclusions:",
            "Is there an opportunity to add/change these?",
            "Explain"
        ],
        "other": [
            "Outline each LOB-Notate any IFP Specific VBC Participation",
            "What is providers’ current performance?",
            "Is there opportunity to remediate or add ACO/VBC"
        ],
    },
    "operationsOverview": {
        "narrative":`Enter narrative, including how the following affects strategy:
             • Top 3-5 provider abrasion points (overall pain points)`,
        "claimsYeild": `Claims Yield-Contract Yield`,
        "topProviderAbrasionPoints": {
            "abrasionPoint1": "UHC Insights data",
            "abrasionPoint2": "Provider advocates",
            "abrasionPoint3": "Past JOC",
            "abrasionPoint4": "",
            "abrasionPoint5": ""
        },
        "claimsYieldContractYield": {
            "contractYield": "$",
            "claimsYield": ""
        },
        "grossYield": {
            "grossYieldEI": "",
            "grossYieldMR": "",
            "grossYieldCS": "",
        },
        "sourceOfInformation": ""
    }
};